'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_Product14__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.n8;
      break;
    }
    case 1: {
      return $thiz.ne;
      break;
    }
    case 2: {
      return $thiz.nf;
      break;
    }
    case 3: {
      return $thiz.ng;
      break;
    }
    case 4: {
      return $thiz.nh;
      break;
    }
    case 5: {
      return $thiz.ni;
      break;
    }
    case 6: {
      return $thiz.nj;
      break;
    }
    case 7: {
      return $thiz.nk;
      break;
    }
    case 8: {
      return $thiz.nl;
      break;
    }
    case 9: {
      return $thiz.n9;
      break;
    }
    case 10: {
      return $thiz.na;
      break;
    }
    case 11: {
      return $thiz.nb;
      break;
    }
    case 12: {
      return $thiz.nc;
      break;
    }
    case 13: {
      return $thiz.nd;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 13)"));
    }
  }
}
export { $f_s_Product14__productElement__I__O as $f_s_Product14__productElement__I__O };
